import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './EarlyAccessDomain.styles';
import {
  setEarlyAccessEmail,
  resetEarlyAccessError,
} from '../../../../store/actions/EarlyAccessActions';
import {
  getIsEarlyAccessEmailValid,
  getEarlyAccessEmail,
} from '../../../../store/selectors/EarlyAccessPageState';
import { AUTO_COMPLETE } from '../../../../constants/constants';
import { getCurrentOrg } from '../../../../store/selectors/CountryStateOrg';

export const VALID_EMAIL_PATTERN = [/^[^@]+@[^@]+\.[^@]+$/];

const EarlyAccessDomain = () => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const emailValid = useSelector(getIsEarlyAccessEmailValid);
  const currentEmail = useSelector(getEarlyAccessEmail);
  const showError =
    currentEmail !== null && currentEmail?.length > 0 && !emailValid;
  const organization = useSelector(getCurrentOrg);
  const onEmailChange = useCallback(
    event => {
      const newEmail = event?.target?.value;
      dispatch(setEarlyAccessEmail(newEmail));
      dispatch(resetEarlyAccessError());
    },
    [dispatch],
  );

  if (!organization) {
    return null;
  }

  return (
    <FormattedMessage id="earlyAccess.domain.label">
      {emailLabel => (
        <TextField
          id="email"
          name="email"
          value={currentEmail || ''}
          onChange={onEmailChange}
          label={emailLabel}
          inputProps={{
            'data-testid': 'email',
            className: classes.input,
          }}
          error={showError}
          required
          autoComplete={AUTO_COMPLETE.EMAIL}
        />
      )}
    </FormattedMessage>
  );
};

export default EarlyAccessDomain;
